// Footer şablon kaydı — admin (gts-web) tarafı.
// gts_ecommerce/src/utils/footerTemplates.ts ile aynı sözleşmeyi taşır.

export type FooterLayoutId = 'layout1' | 'layout2';

export const DEFAULT_FOOTER_LAYOUT: FooterLayoutId = 'layout1';

/** layout2: marka + ok işaretli sütunlar, güven şeridi, tüzel unvan. */
export function normalizeFooterLayout(value?: string | null): FooterLayoutId {
  const raw = String(value || '').trim().toLowerCase();
  if (raw === 'layout2' || raw === 'corporate' || raw === 'trust') {
    return 'layout2';
  }
  return DEFAULT_FOOTER_LAYOUT;
}

export function isCorporateFooter(value?: string | null): boolean {
  return normalizeFooterLayout(value) === 'layout2';
}
